import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=28ad7cc0&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad7cc0",
  null
  
)

export default component.exports